import React from 'react';
import { Link } from 'react-router-dom';
import { MentalLinkIdentifier, MentalKnowHowMainData } from '../../types';
import PageTitle from '../../components/PageTitle';
import TipsAndTricks from './TipsAndTricks';

type Props = {
    mental: MentalLinkIdentifier,
    knowHowMainInfo: MentalKnowHowMainData
}

export default ({ knowHowMainInfo }: Props) => (
    <div className="knowhow-container">
        <PageTitle documentTitleParts={[knowHowMainInfo.mentalTitle, 'Know How', knowHowMainInfo.title]}>
            <span className="mobile-parent-title">
                {knowHowMainInfo.mentalTitle.length > 20 ? `${knowHowMainInfo.mentalTitle.substring(0, 20)}...` : knowHowMainInfo.mentalTitle}
            </span>
            <span className="parent-title">{knowHowMainInfo.mentalTitle}</span>
            <strong>Know how</strong>
        </PageTitle>
        {knowHowMainInfo.title && (
            <div className="knowhow-title">
                {knowHowMainInfo.title}
            </div>
        )}
        <div dangerouslySetInnerHTML={{ __html: knowHowMainInfo.text }} />
        {knowHowMainInfo.tips && (
            <TipsAndTricks tips={knowHowMainInfo.tips} color={knowHowMainInfo.mainColor} />
        )}
        {knowHowMainInfo.textLinks && (
            <section>
                <h4>Was dich ebenfalls interessieren könnte...</h4>
                <ul className="knowhow-links">
                    {knowHowMainInfo.textLinks.map(textLink => (
                        <li key={textLink.id}>
                            <Link to={textLink.link} style={{ color: knowHowMainInfo.mainColor }}>
                                <span className="bullet" style={{ backgroundColor: knowHowMainInfo.mainColor }} />
                                {textLink.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            </section>
        )}
    </div>
);
